<button class="icon-button" [attr.data-variant]="variant" [attr.data-size]="size" [attr.data-disabled]="disabled"
  [attr.data-loading]="loading" [disabled]="disabled || loading" [attr.aria-label]="ariaLabel || 'Icon button'"
  (click)="onButtonClick($event)" type="button">

  <!-- Loading spinner -->
  <span *ngIf="loading" class="loading-spinner" aria-hidden="true">⟳</span>

  <!-- Icon -->
  <span *ngIf="!loading && iconName" class="icon-wrapper" aria-hidden="true">
    <umss-icon [name]="iconName" [size]="computedIconSize" [color]="iconColor"></umss-icon>
  </span>
</button>